import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import Landing from './pages/Landing';
import SignIn from './pages/SignIn';
import SignUp from './pages/SignUp';
import OTPVerification from './pages/OTPVerification';
import AppLayout from './components/app/AppLayout';
import ProtectedOTPRoute from './components/ProtectedOTPRoute';
import { userPool } from './config/cognitoConfig';

function ProtectedRoute({ children }) {
  const { isLoggedIn, loading } = useAuth();
  const location = useLocation();

  useEffect(function () {
    // Check session validity periodically
    if (isLoggedIn) {
      const checkSession = setInterval(function () {
        const cognitoUser = userPool.getCurrentUser();
        if (cognitoUser) {
          cognitoUser.getSession(function (err, session) {
            if (err || !session || !session.isValid()) {
              // Session expired, redirect to signin
              window.location.href = '/signin';
            }
          });
        } else {
          // No user found, redirect to signin
          window.location.href = '/signin';
        }
      }, 60000); // Check every minute

      return function () {
        clearInterval(checkSession);
      };
    }
  }, [isLoggedIn]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!isLoggedIn) {
    // Store intended destination for redirect after login
    return <Navigate to="/signin" state={{ from: location.pathname }} replace />;
  }

  return children;
}

// function ProtectedApp() {
//   const { isLoggedIn } = useAuth();
//   // if (!isLoggedIn) {
//   //   return <Navigate to="/signin" replace />;
//   // }
//   return (
//     <Routes>
//       <Route path="/app" element={<AppLayout />}>
//         <Route index element={null} />
//         <Route path="whatsapp-success" element={<WhatsAppSuccess />} />
//       </Route>
//       <Route path="*" element={<Navigate to="/app" replace />} />
//     </Routes>
//   );
// }

// function App() {
//   return (
//     <div className="App">
//       <Routes>
//         <Route path="/" element={<Landing />} />
//         <Route path="/signin" element={<SignIn />} />
//         <Route path="/signup" element={<SignUp />} />
//         <Route path="/app/*" element={<ProtectedApp />} />
//       </Routes>
//     </div>
//   );
// }

function App() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/signin" element={<SignIn />} />
      <Route path="/signup" element={<SignUp />} />
      <Route 
        path="/otp-verification" 
        element={
          <ProtectedOTPRoute>
            <OTPVerification />
          </ProtectedOTPRoute>
        } 
      />

      <Route
        path="/app/*"
        element={
          <ProtectedRoute>
            <AppLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={null} />
        <Route path="configurations" element={null} />
        <Route path="visualization" element={null} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}


export default App;
